import actions from "./actions";
import mutations from "./mutations";
import RolesAndPermissionsStore from "../RolesAndPermissions/store";
import AccountSettingsStore from "../AccountSettings/store";

export default {
  namespaced: true,
  state: {
    roles: [],
    currentPage: 1,
    perPage: 5,
    payload: null,
  },
  actions,
  mutations,
  modules: {
    rolesAndPermissions: RolesAndPermissionsStore,
    AccountSettings: AccountSettingsStore,
  },
};
